import React from "react";
import { Button, Card, Result } from "antd";
import { useLoader } from "../../../Context/LoaderContext/LoaderContext";

interface SuccessResultProps {
  title: string;
  subTitle: string;
  onClick?: () => void;
  buttonTitle?: string;
}
const SuccessResult: React.FC<SuccessResultProps> = ({
  title,
  subTitle,
  onClick,
  buttonTitle,
}) => {
  const { isLoading } = useLoader();

  return (
    <Card bordered={false} style={{ boxShadow: "none" }}>
      <Result
        status="success"
        title={title}
        subTitle={subTitle}
        extra={
          onClick && (
            <Button type="primary" onClick={onClick} loading={isLoading}>
              {buttonTitle ? buttonTitle : "Button"}
            </Button>
          )
        }
      />
    </Card>
  );
};

export default SuccessResult;
